import { FC } from "react";
import styles from "../Defect.module.scss";

interface SmsStatusProps {
  label: string;
  value: any;
}

const SmsStatus: FC<SmsStatusProps> = ({ label, value}) => {
  return (
    <div className={styles.defect__cardSmsStatus}>
      <div className={styles.defect__cardLabel}>{label}</div>
      <div className={styles.defect__cardStatus}>{value}</div>
    </div>
  );
};

export default SmsStatus;